export default __webpack_public_path__ + "static/media/win.ba921d00.mp3";